import React from "react";
import Marquee from "react-fast-marquee";
import { SITE } from "../../config/site";

export const TrustMarquee = () => {
  const items = [
    `${SITE.legalName} (${SITE.jurisdiction})`,
    SITE.city,
    "VYNLWORLD\u2122",
    "Powered by Stripe & Printful",
  ];

  return (
    <section data-testid="trust-strip" className="relative py-8 border-y overflow-hidden" style={{ borderColor: "#2A2233", backgroundColor: "#0E0A16" }}>
      <Marquee speed={26} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-8 font-display uppercase tracking-[0.28em] text-sm md:text-base" style={{ color: "#9B8FAC" }}>
              {it}
            </span>
            <span className="text-sm" style={{ color: "#C724B1" }}>·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default TrustMarquee;
